"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Youtube = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M12.2807919,6.00098118 C13.3528868,6.00686827 17.1816104,6.04807792 18.2510909,6.33654545 C18.9395455,6.52172727 19.4816364,7.06736364 19.6656364,7.76027273 C19.9628485,8.87655556 19.9958721,11.0709259 19.9995413,11.5447825 L19.999983,11.6257831 L19.999983,11.6257831 L20,11.6363636 C20,11.6363636 20,11.6399579 19.999983,11.6469439 L19.9995413,11.7279419 C19.9958721,12.2017845 19.9628485,14.396101 19.6656364,15.5125455 C19.4816364,16.2053636 18.9395455,16.751 18.2510909,16.9362727 C17.145961,17.2342753 13.0945728,17.2683328 12.1829755,17.272225 L11.8170245,17.272225 C10.9054272,17.2683328 6.85403896,17.2342753 5.74890909,16.9362727 C5.06054545,16.751 4.51836364,16.2053636 4.33436364,15.5125455 C4.03715152,14.396101 4.00412795,12.2017845 4.00045866,11.7279419 L4.00045866,11.5447825 C4.00412795,11.0709259 4.03715152,8.87655556 4.33436364,7.76027273 C4.51836364,7.06736364 5.06054545,6.52172727 5.74890909,6.33654545 C6.81838961,6.04807792 10.6471132,6.00686827 11.7192081,6.00098118 Z M10.3636364,9.25736364 L10.3636364,14.0153636 L14.5454545,11.6364545 L10.3636364,9.25736364 Z", fillRule: "evenodd" })));
};
Youtube.displayName = 'Youtube';
exports.default = Youtube;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Youtube.js.map